/** `completed` out of `total` as a percentage, 0 for an empty total and never above 100. */
export function toPercentage(completed: number, total: number): number {
  return total === 0 ? 0 : Math.min(100, (completed / total) * 100);
}
